/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Empty_StarInputs */

const en_common_empty_star = /** @type {(inputs: Common_Empty_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empty star`)
};

const es_common_empty_star = /** @type {(inputs: Common_Empty_StarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrella vacía`)
};

/**
* | output |
* | --- |
* | "Empty star" |
*
* @param {Common_Empty_StarInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_empty_star = /** @type {((inputs?: Common_Empty_StarInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Empty_StarInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_empty_star(inputs)
	return en_common_empty_star(inputs)
});